'use client'

import Link from 'next/link'
import type { ComponentType } from 'react'

/**
 * Polaris linkComponent that uses Next.js Link for in-app (relative) URLs
 * so navigation is client-side and does not trigger full document reloads.
 * External URLs still use a plain anchor with target="_blank".
 */
export type PolarisLinkProps = {
  url: string
  children?: React.ReactNode
  external?: boolean
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>

function isInternalUrl(url: string): boolean {
  if (typeof url !== 'string') return false
  return url.startsWith('/') || url.startsWith('#')
}

export const PolarisLink: ComponentType<PolarisLinkProps> = function PolarisLink({
  url,
  children,
  external,
  ...rest
}) {
  if (external || !isInternalUrl(url)) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    )
  }
  return (
    <Link href={url} {...rest}>
      {children}
    </Link>
  )
}
